import type { DealsListFiltersValue } from '@openx/types/deal';

const CLEARABLE_FILTER_KEYS = ['account', 'status', 'createdBy', 'health_score_min', 'health_score_max'] as const;

export const clearFastFilterEntries = (filters: DealsListFiltersValue): DealsListFiltersValue => {
  const nextFilters = { ...filters };

  for (const key of CLEARABLE_FILTER_KEYS) {
    nextFilters[key] = undefined;
  }

  return nextFilters;
};
